import { find, remove } from 'lodash';
import { trackEvent } from 'util/tracking';
import * as types from 'framework/vuex/mutation-types';
import { currentOverlay } from './getters';

function closeOverlay(state, id) {
    /** @type {IOverlay} */
    const overlay = find(state.overlays, { id });
    if (!overlay) {
        return;
    }

    overlay.isActive = false;
}

export default {
    /**
     * Add overlay to the store
     * @param {object} state
     * @param {string} id
     * @param {string} component
     * @param {object} args
     */
    [types.REGISTER_OVERLAY](state, { id, component, args }) {
        state.overlays.push({ id, component, args, isActive: false });
    },

    [types.UNREGISTER_OVERLAY](state, { id }) {
        const overlayToRemove = find(state.overlays, { id });
        remove(state.overlays, overlayToRemove);
    },

    [types.OPEN_OVERLAY](state, { id, trackingId }) {
        const currentlyActiveOverlay = currentOverlay(state);
        if (currentlyActiveOverlay) {
            closeOverlay(state, currentlyActiveOverlay.id);
        }

        /** @type {IOverlay} */
        const overlay = find(state.overlays, { id });
        if (!overlay) {
            return;
        }

        trackEvent({
            event: 'overlayOpened',
            overlayLabel: trackingId,
            category: `overlay ${ document.documentElement.lang }`,
        });

        overlay.isActive = true;
    },

    [types.CLOSE_OVERLAY](state, { id }) {
        closeOverlay(state, id);
    },
};
